export default {
  inventarioTableHeaders: [
    {
      text: 'codigoProduto',
      value: 'codigoProduto',
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'codigoProduto',
      },
    },
    {
      text: 'descricaoProduto',
      value: 'descricaoProduto',
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'descricaoProduto',
      },
    },
    {
      text: 'quantidadeEstoque',
      value: 'quantidadeEstoque',
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'quantidadeEstoque',
      },
    },
    {
      text: 'quantidadeInventario',
      value: 'quantidadeInventario',
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'quantidadeInventario',
      },
    },
    {
      text: 'diferenca',
      value: 'diferenca',
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'diferenca',
      },
    },
    {
      text: 'inventario',
      value: 'inventario',
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'inventario',
      },
    },
    {
      text: 'estado',
      value: 'estado',
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'estado',
      },
    },
  ],
  inventarioTableItems: [],
  precisaoInventario: [],
  inventariosRealizados: [],
  historicoProdutosInventario: [],
  filtros: {
    termo: '',
    page: 1,
    perPage: 20,
    order: 'descricaoProduto',
    direcao: 'DESC',

    codigoProduto: '',
    descricaoProduto: '',
    quantidadeEstoque: '',
    quantidadeInventario: '',
    diferenca: '',
    inventario: '',
    estado: '',

    empresaSelecionada: '',
  },
};
